import { Row as AntdRow } from 'antd';
import type { RowProps }  from 'antd';

const Row = (props: RowProps) => <AntdRow gutter={[16, 16]} {...props} />;

export default Row;